export default {
  path: '/scheme/index/:id',
  name: 'Scheme.Index',
  component: () => import(/* webpackChunkName: "form" */ '@/views/modules/scheme/index/Index.vue'),
  hiddenInMenu: true,
  meta: {
    title: '方案秀',
    icon: 'database',
  },
};
